import axios from 'axios';

export const ApiTracking = axios.create({
  baseURL: 'https://lpdb.sos-verkehrsrecht.de/l',
  timeout: 5000,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
});

export const ApiFormEncoded = axios.create({
  baseURL: '/',
  timeout: 5000,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
});

export const ApiJSON = axios.create({
  baseURL: '/',
  timeout: 5000,
  headers: { 'Content-Type': 'application/json' },
});
